import Swiper from 'swiper/bundle';
import ScrollOut from 'scroll-out';

export default () => {
  renderDesktopWelcome();

  window.addEventListener('resize', () => {
    renderDesktopWelcome();
  });

  function renderDesktopWelcome() {
    // if (window.site_vw > 1023) {
      let images_wrapper = document.querySelectorAll('.Welcome__Image');
      let welcome_left_images = document.querySelector('.js-left-images');
      let welcome_right_images = document.querySelector('.js-right-images');
      if (welcome_left_images && images_wrapper) {
        let first_image = welcome_left_images.querySelector('.Welcome__Image--First img');
        let third_image = welcome_left_images.querySelector('.Welcome__Image--Third img');
        let left_total_height = first_image.height + third_image.height - (third_image.height * 0.15);

        if (window.site_vw > 640 && window.site_vw < 1024) {
          left_total_height = Math.max(first_image.height, third_image.height)
        }

        welcome_left_images.style.height = left_total_height+'px';
      }
      if (welcome_right_images) {
        let second_image = welcome_right_images.querySelector('.Welcome__Image--Second img');
        let fourth_image = welcome_right_images.querySelector('.Welcome__Image--Fourth img');
    
        let right_total_height = second_image.height + fourth_image.height - (fourth_image.height * 0.15);

        if (window.site_vw > 640 && window.site_vw < 1024) {
          right_total_height = Math.max(second_image.height, fourth_image.height)
        }
        
        welcome_right_images.style.height = right_total_height+'px';
      }
    // }
  }

  const welcome_slider = document.querySelector('.js-welcome-products-swiper');
  if (welcome_slider) {
    let initSlider = new Swiper(welcome_slider, {
      slidesPerView: 1,
      centeredSlides: true,
      // autoplay: {
      //   disableOnInteraction: false,
      // },
      loop: true,
      longSwipesMs: 1000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
      on: {
        resize: function (swiper) {
          swiper.slides.forEach(element => {
            // element.querySelector('.ProductCard__Wrapper').style.height = "200px"
            let imageHeight = +element.querySelector('.ProductCard__Image').scrollHeight;
            let bottomHeight = +element.querySelector('.ProductCard__Bottom').dataset.height;
            let total_height = imageHeight + bottomHeight;
            element.querySelector('.ProductCard__Wrapper').style.height = total_height + "px";
          });
        },
      },
    });

    enlargeBottom(initSlider, initSlider.activeIndex);

    initSlider.on('slideChangeTransitionEnd', function (i) {
      initSlider.slides.forEach(item => {
        let bottom = item.querySelector('.ProductCard__Bottom');
        bottom.style.visibility = 'hidden';
        bottom.style.height = '0px';
      });
      enlargeBottom(initSlider, i.activeIndex);
    });
  }

  function enlargeBottom(slider,current) {
    setTimeout(() => {
      let bottom = slider.slides[current].querySelector('.ProductCard__Bottom');
      bottom.style.visibility = 'visible';
      bottom.style.height = bottom.dataset.height+'px';
    }, 100);
  }

  const welcomeSection = document.querySelector('.SectionBlock--Welcome');
  const welcomeTitle = document.querySelector('.js-welcome-title');
  if (welcomeSection && welcomeTitle) {
    ScrollOut({
      targets: welcomeSection,
      offset: () => window.innerHeight / 2,
      onShown() {
        welcomeTitle.classList.add('is-animated');
      },
    })
  }
}